"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectCreationMetaResponseModelStatus = void 0;
exports.ProjectCreationMetaResponseModelStatus = {
    Pending: "pending",
    Creating: "creating",
    Finished: "finished",
    Failed: "failed",
};
